
import React from 'react';

const Tsd = ({ title, subTitle, description, ps, className = '', titleClassName = '', subTitleClassName = '', descriptionClassName = '', psClassName = '' }) =>
  (<section className={className} id="features">
    <div className="container c-mw">
      <div className="row">
        <div className="col-12">
          {title && (
            <h2 className={titleClassName}>{title}</h2>
          )}
          {subTitle && (
            <h4 className={`c-light ${subTitleClassName}`} dangerouslySetInnerHTML={{ __html: subTitle }}></h4>
          )}
          {description && (
            <p className={`md-3 ${descriptionClassName}`}>{subTitle}</p>
          )}
          {ps && ps.map((label, i) => (
            <p className={psClassName} key={i}>
              {label}
            </p>
          ))}
        </div>
      </div>
    </div>
  </section>);

export default Tsd;



// WEBPACK FOOTER //
// ./src/components/common/Tsd.js